import React, { useContext, useState, useEffect } from 'react'
import initializeFeatures from './initializeFeatures'
import FeatureFlagContext from './FeatureFlagContext'
import { withAuthProvider } from '../auth'
import { LoadingComponent } from '@pga/pga-component-library/lib/components/LoadingComponent'
import { UserContext } from '../UserProvider/'
import { getIsImpersonating } from './utils'

const FeatureFlagProvider = withAuthProvider(props => {
  const [featureFlags, setFeatureFlags] = useState()
  const { App, externalId, email, isImpersonating } = props

  useEffect(() => {
    const getFeatures = async () => {
      const flags = await initializeFeatures({ externalId, email, isImpersonating })
      setFeatureFlags(flags)
    }
    getFeatures()
  }, [externalId, email, isImpersonating])

  if (featureFlags === undefined) {
    return <LoadingComponent />
  }

  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      <App {...props} />
    </FeatureFlagContext.Provider>
  )
})

const withFeatureFlagProvider = App => props => {
  const { user } = useContext(UserContext)

  const isImpersonating = getIsImpersonating()

  return <FeatureFlagProvider externalId={user?.externalId} email={user?.primaryEmail} isImpersonating={isImpersonating} App={App} {...props} />
}

export default withFeatureFlagProvider
